import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/common/img-pagetop.svg'


const _withScopeId = n => (_pushScopeId("data-v-6559fd74"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#e6eff6"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-recommend --no-pt-sp" }
const _hoisted_4 = { class: "p-recommend-nav" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, [
  /*#__PURE__*/_createTextVNode("転職希望"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("アンケート")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "書類作成", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "書類提出", -1))
const _hoisted_8 = { class: "p-recommend-inner" }
const _hoisted_9 = { class: "p-recommend-group-1" }
const _hoisted_10 = { class: "p-recommend-group-1__head" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "p-recommend-heading-1" }, "転職希望アンケート", -1))
const _hoisted_12 = {
  key: 0,
  class: "p-recommend-notice-1 --color-1"
}
const _hoisted_13 = {
  key: 1,
  class: "p-recommend-notice-1 --color-2"
}
const _hoisted_14 = { class: "p-recommend-group-1__body" }
const _hoisted_15 = {
  key: 0,
  class: "p-recommend-set"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "希望する勤務地", -1))
const _hoisted_17 = { class: "p-recommend-text-1" }
const _hoisted_18 = {
  key: 1,
  class: "p-recommend-set"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "転居の可能性", -1))
const _hoisted_20 = { class: "p-recommend-text-1" }
const _hoisted_21 = {
  key: 2,
  class: "p-recommend-set"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "希望業種", -1))
const _hoisted_23 = {
  key: 0,
  class: "p-recommend-text-1"
}
const _hoisted_24 = {
  key: 3,
  class: "p-recommend-set"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "希望職種", -1))
const _hoisted_26 = {
  key: 0,
  class: "p-recommend-text-1"
}
const _hoisted_27 = {
  key: 4,
  class: "p-recommend-set"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "希望する従業員数", -1))
const _hoisted_29 = { class: "p-recommend-text-1" }
const _hoisted_30 = {
  key: 5,
  class: "p-recommend-set"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "希望する年収", -1))
const _hoisted_32 = { class: "p-recommend-text-1" }
const _hoisted_33 = {
  key: 6,
  class: "p-recommend-set"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "最低希望年収", -1))
const _hoisted_35 = { class: "p-recommend-text-1" }
const _hoisted_36 = {
  key: 7,
  class: "p-recommend-set"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "転職希望時期", -1))
const _hoisted_38 = { class: "p-recommend-text-1" }
const _hoisted_39 = {
  key: 8,
  class: "p-recommend-set"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "転職理由、転職を考えたきっかけ", -1))
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = {
  key: 9,
  class: "p-recommend-set"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "転職で優先したいこと、叶えたいこと", -1))
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = {
  key: 10,
  class: "p-recommend-set"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "転職活動で利用しているもの", -1))
const _hoisted_47 = ["innerHTML"]
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["innerHTML"]
const _hoisted_50 = {
  key: 11,
  class: "p-recommend-set"
}
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "転職活動状況", -1))
const _hoisted_52 = { class: "heading-job-status" }
const _hoisted_53 = ["innerHTML"]
const _hoisted_54 = ["innerHTML"]
const _hoisted_55 = ["innerHTML"]
const _hoisted_56 = ["innerHTML"]
const _hoisted_57 = {
  key: 12,
  class: "p-recommend-set"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "応募を検討中の企業", -1))
const _hoisted_59 = ["innerHTML"]
const _hoisted_60 = {
  key: 13,
  class: "p-recommend-set"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-recommend-heading-2" }, "マイナビ転職AGENTを利用する目的・期待すること", -1))
const _hoisted_62 = ["innerHTML"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "編集する", -1))
const _hoisted_64 = { class: "l-wrapper_nav" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_67 = [
  _hoisted_66
]

import { onMounted, ref } from 'vue';
import { RouterLink } from 'vue-router';
import { getCareerInfoRecommendService, isShowWarningRecommendService } from '@/api/services/trnCareerService';
import store from '@/store';
import { Recommend, TrnJobChangeStatusSelectForm } from '@/types';
import Loading from '@/components/Loading.vue';
import { join } from 'lodash';
import { getMstNameByIdService } from '@/api/services/mstMyPageService';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { domHelperUtils } from '@/utils/domHelper';

export default /*#__PURE__*/_defineComponent({
  __name: 'RecommendView',
  setup(__props) {

const storeBase = MYPAGE_CONSTANTS.STORE_MST;
const recommendConst = MYPAGE_CONSTANTS.RECOMMEND;
const colonSpace = MYPAGE_CONSTANTS.STRING.COLON_SPACE;

const recomend = ref<Recommend>({});
const isLoading = ref(false);

function scrollToTop() {
  domHelperUtils.scrollToTop();
}

onMounted(async () => {
  await loadRecomendData();
});


const getRecommend = async () : Promise<Recommend> => {
  const recomend : Recommend = {isShowButtonMissData:false};
  let i = 0;
  const careerInfo = await getCareerInfoRecommendService();
  if(!(careerInfo))
  {
      return recomend;
  }

  recomend.isShowButtonMissData = await isShowWarningRecommendService(careerInfo);
  // wishWkArea - 希望する勤務地
  if(careerInfo.wishWkAreaAllFlg == 1)
  {
    recomend.wishWKArea = '全国可';
  }
  else
  {
    const recomendArr : string[] = [];
    let wishWkAreaIds: number[] = [];
  
    if(careerInfo.wishWkAreaId)
    {
      const ids = String(careerInfo.wishWkAreaId);
      wishWkAreaIds = ids.split('/').filter(i => i).map(Number);
    }
    for(i = 0; i < wishWkAreaIds.length; i++)
    {
      if(wishWkAreaIds[i])
      {
        const prefName = await getMstNameByIdService(wishWkAreaIds[i], storeBase.MST_PREF, store);
        if(prefName)
        {
          recomendArr.push(prefName);
        }
      }
    }

    if(recomendArr.length > 0)
    {
      recomend.wishWKArea = recomendArr.join('/');
    }
  }

  // changeAddr - 転居の可能性
  if(careerInfo.changeAddrFlg)
  {
    const changeAddrName = await getMstNameByIdService(careerInfo.changeAddrFlg, storeBase.MST_CHANGE_ADDR, store);
    if(changeAddrName)
    {
      recomend.changeAddr = changeAddrName;
    }
  }      

  // wishIndsCtg - 希望業種
  if(careerInfo.wishIndsCtgNotParticularFlg)
  {
    recomend.wishIndsCtgNotParticularFlg = true;
  }
  else
  {
    const lsWishIndsCtg = [];
    for(let i = 1; i <= recommendConst.MAX_WISH_INDUSTRY; i++)
    {
      if((careerInfo as any)[`wishIndsCtg${i}Id`])
      {
        const indsCtgName = await getMstNameByIdService((careerInfo as any)[`wishIndsCtg${i}Id`], storeBase.MST_INDUSTRY, store);
        if(indsCtgName)
        {
          lsWishIndsCtg.push(i + ' ' + indsCtgName);
        }
      }
    }

    if(lsWishIndsCtg.length > 0)
    {
        recomend.wishIndsCtgs = lsWishIndsCtg;
    }
  }

  // wishOcupCtgs - 希望職種
  if(careerInfo.wishOcupCtgNotParticalarFlg)
  {
    recomend.wishOcupCtgNotParticalarFlg = true;
  }
  else
  {
    const lswishOcupCtg = [];
    for(let i= 1; i <= recommendConst.MAX_WISH_OCCUP; i++)
    {
      //careerInfo.wishOcupCtg1Id
      if((careerInfo as any)[`wishOcupCtg${i}Id`])
      {        
        const ocupCtgName = await getMstNameByIdService((careerInfo as any)[`wishOcupCtg${i}Id`], storeBase.MST_OCUP3, store);
        if(ocupCtgName)
        {
          lswishOcupCtg.push(i + ' ' + ocupCtgName);
        }
      }
    }

    if(lswishOcupCtg.length > 0)
    {
        recomend.wishOcupCtgs = lswishOcupCtg;
    }
  }

  // wishEmployee - 希望する従業員数
  if(careerInfo.wishEmployeeId)
  {
    recomend.wishEmployee = await getMstNameByIdService(careerInfo.wishEmployeeId, storeBase.MST_EMPLOYEE, store);
  }

  // wishSalary - 希望する年収
  if(careerInfo.wishSalaryNotParticularFlg)
  {
      recomend.wishSalary = 'こだわらない';
  }
  else
  {
    recomend.wishSalary = careerInfo.wishAnnualIncomeNum?  careerInfo.wishAnnualIncomeNum + '万円' : '';
  }

  // minWishAnnualIncomeNum - 最低希望年収
  recomend.minWishAnnualIncomeNum = careerInfo.minWishAnnualIncomeNum?  careerInfo.minWishAnnualIncomeNum + '万円' : '';

  // jobChange - 転職希望時期
  if(careerInfo.jobChangeFlg)
  {
    recomend.jobChange = await getMstNameByIdService(careerInfo.jobChangeFlg, storeBase.MST_JOB_CHANGE_TIME, store);
  }

  // changeJobReason - 転職理由、転職を考えたきっかけ
  recomend.changeJobReason = careerInfo.changeJobReason? careerInfo.changeJobReason.replaceAll('\n', '<br/>'):'';

  // changeJobPriority - 転職で優先したいこと、叶えたいこと
  recomend.changeJobPriority = careerInfo.changeJobPriority? careerInfo.changeJobPriority.replaceAll('\n', '<br/>'):'';

  // careerChangeAgent - 転職エージェント
  if(careerInfo.careerChangeAgentFlg == 1)
  {
    recomend.careerChangeAgentMemo = '転職エージェント' + colonSpace + 'あり' + (careerInfo.careerChangeAgentMemo?'<br/>' + careerInfo.careerChangeAgentMemo : '');
  }
  else
  {
    if(careerInfo.careerChangeAgentFlg == 2)
    {
        recomend.careerChangeAgentMemo = '転職エージェント' + colonSpace + 'なし';
    }
  }

  // jobChangeSite - 転職サイト
  if(careerInfo.jobChangeSiteFlg == 1)
  {
    recomend.jobChangeSiteMemo = '転職サイト' + colonSpace + 'あり' + (careerInfo.jobChangeSiteMemo?'<br/>' + careerInfo.jobChangeSiteMemo : '');
  }
  else
  {
    if(careerInfo.jobChangeSiteFlg == 2)
    {
        recomend.jobChangeSiteMemo = '転職サイト' + colonSpace + 'なし';
    }
  }

  // helloWorkFlg - ハローワーク
  if(careerInfo.helloWorkFlg == 1)
  {
    recomend.helloWorkMemo = 'ハローワーク' + colonSpace + 'あり';
  }
  else
  {
    if(careerInfo.helloWorkFlg == 2)
    {
        recomend.helloWorkMemo = 'ハローワーク' + colonSpace + 'なし';
    }
  }

  // clientNameRemindOtherFlg - 応募を検討中の企業
  if(careerInfo.clientNameRemindOtherFlg)
  {
    recomend.clientNameRemindOther = '特になし';
  }
  else
  {
    recomend.clientNameRemindOther = careerInfo.clientNameRemindOther;
  }

  // purposeAgentIds - マイナビAGENTを利用する目的・期待すること  
  const lsPurposeAgentName = [];
  if(careerInfo.purposeAgentId)
  {
    const purposeAgentIds = careerInfo.purposeAgentId.split('/').filter(i => i);
    for(let i= 0; i< purposeAgentIds.length; i ++)
    {
      const purposeAgentName = await getMstNameByIdService(purposeAgentIds[i], storeBase.MST_PURPOSEAGENT, store);
      if(purposeAgentName)
      {
        lsPurposeAgentName.push(purposeAgentName);
      }
    }     
  }

  if(careerInfo.purposeAgentMemo)
  {
    lsPurposeAgentName.push('その他' + colonSpace);
    lsPurposeAgentName.push(careerInfo.purposeAgentMemo.replaceAll('\n', '<br/>'));
  }

  if(lsPurposeAgentName.length)
  {
    recomend.purposeAgentMemo = join(lsPurposeAgentName, '</br>');
  }

  if(careerInfo.lsTrnJobChangeStatus)
  {
    recomend.lsTrnJobChangeStatus = [];
    for(let element of careerInfo.lsTrnJobChangeStatus)
    {
      const jobStatus : TrnJobChangeStatusSelectForm = {};
      if(element.clientNameRemind)
      {
        jobStatus.clientNameRemind = '企業名' + colonSpace + element.clientNameRemind;
      }

      if(element.selectionPhaseId)
      {
        const selectionPhaseName = await getMstNameByIdService(element.selectionPhaseId, storeBase.MST_SELECTION_PHASE, store);
        jobStatus.selectionPhaseName = selectionPhaseName? '選考フェーズ' + colonSpace + selectionPhaseName: '';
      }

      
      if(element.aspirationId)
      {
        const aspirationName = await getMstNameByIdService(element.aspirationId, storeBase.MST_ASPIRATION, store);
        jobStatus.aspirationName = aspirationName? '志望度' + colonSpace + aspirationName: '';
      }

      if(element.courseId)
      {
        const courseName = await getMstNameByIdService(element.courseId, storeBase.MST_COURSE, store);
        jobStatus.courseName = courseName? '経路' + colonSpace + courseName: '';
      }

      recomend.lsTrnJobChangeStatus?.push(jobStatus);
    }
  }

  return recomend;
};

const loadRecomendData = async () => {
  isLoading.value = true;
  const recommendResp = await getRecommend(); 
  if(recommendResp)
  {
    recomend.value = recommendResp;
  }
  isLoading.value = false;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            _createElementVNode("li", null, [
              _createVNode(_unref(RouterLink), {
                to: "/recommend/",
                "active-class": "-is-current",
                "exact-active-class": "-is-current"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(RouterLink), {
                to: "/resume/",
                "active-class": "-is-current",
                "exact-active-class": "-is-current"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_unref(RouterLink), {
                to: "/resume/submitadvisor/",
                "active-class": "-is-current",
                "exact-active-class": "-is-current"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                (recomend.value.isShowButtonMissData)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "未入力あり"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, "入力済"))
              ]),
              _createElementVNode("div", _hoisted_14, [
                (recomend.value.wishWKArea)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _hoisted_16,
                      _createElementVNode("p", _hoisted_17, _toDisplayString(recomend.value.wishWKArea), 1)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.changeAddr)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("p", _hoisted_20, _toDisplayString(recomend.value.changeAddr), 1)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.wishIndsCtgNotParticularFlg || (recomend.value.wishIndsCtgs && recomend.value.wishIndsCtgs.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _hoisted_22,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recomend.value?.wishIndsCtgs, (value, index) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "p-recommend-text-1",
                          key: index
                        }, _toDisplayString(value), 1))
                      }), 128)),
                      (recomend.value.wishIndsCtgNotParticularFlg)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_23, "こだわらない"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.wishOcupCtgNotParticalarFlg || (recomend.value.wishOcupCtgs && recomend.value.wishOcupCtgs.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _hoisted_25,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recomend.value?.wishOcupCtgs, (value, index) => {
                        return (_openBlock(), _createElementBlock("p", {
                          class: "p-recommend-text-1",
                          key: index
                        }, _toDisplayString(value), 1))
                      }), 128)),
                      (recomend.value.wishOcupCtgNotParticalarFlg)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, "こだわらない"))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.wishEmployee)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("p", _hoisted_29, _toDisplayString(recomend.value.wishEmployee), 1)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.wishSalary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("p", _hoisted_32, _toDisplayString(recomend.value.wishSalary), 1)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.minWishAnnualIncomeNum)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("p", _hoisted_35, _toDisplayString(recomend.value.minWishAnnualIncomeNum), 1)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.jobChange)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("p", _hoisted_38, _toDisplayString(recomend.value.jobChange), 1)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.changeJobReason)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("p", {
                        class: "p-recommend-text-1",
                        innerHTML: recomend.value.changeJobReason
                      }, null, 8, _hoisted_41)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.changeJobPriority)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                      _hoisted_43,
                      _createElementVNode("p", {
                        class: "p-recommend-text-1",
                        innerHTML: recomend.value.changeJobPriority
                      }, null, 8, _hoisted_44)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.careerChangeAgentMemo || recomend.value.jobChangeSiteMemo || recomend.value.helloWorkMemo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _hoisted_46,
                      (recomend.value.careerChangeAgentMemo)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 0,
                            class: "p-recommend-text-1",
                            innerHTML: recomend.value.careerChangeAgentMemo
                          }, null, 8, _hoisted_47))
                        : _createCommentVNode("", true),
                      (recomend.value.jobChangeSiteMemo)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            class: "p-recommend-text-1",
                            innerHTML: recomend.value.jobChangeSiteMemo
                          }, null, 8, _hoisted_48))
                        : _createCommentVNode("", true),
                      (recomend.value.helloWorkMemo)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 2,
                            class: "p-recommend-text-1",
                            innerHTML: recomend.value.helloWorkMemo
                          }, null, 8, _hoisted_49))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.lsTrnJobChangeStatus && recomend.value.lsTrnJobChangeStatus.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _hoisted_51,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recomend.value.lsTrnJobChangeStatus, (job, i) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: i,
                          class: "js-entry-item"
                        }, [
                          _createElementVNode("h3", _hoisted_52, "企業" + _toDisplayString(i + 1), 1),
                          (recomend.value.lsTrnJobChangeStatus[i].clientNameRemind)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 0,
                                class: "p-recommend-text-1",
                                innerHTML: recomend.value.lsTrnJobChangeStatus[i].clientNameRemind
                              }, null, 8, _hoisted_53))
                            : _createCommentVNode("", true),
                          (recomend.value.lsTrnJobChangeStatus[i].selectionPhaseName)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 1,
                                class: "p-recommend-text-1",
                                innerHTML: recomend.value.lsTrnJobChangeStatus[i].selectionPhaseName
                              }, null, 8, _hoisted_54))
                            : _createCommentVNode("", true),
                          (recomend.value.lsTrnJobChangeStatus[i].aspirationName)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 2,
                                class: "p-recommend-text-1",
                                innerHTML: recomend.value.lsTrnJobChangeStatus[i].aspirationName
                              }, null, 8, _hoisted_55))
                            : _createCommentVNode("", true),
                          (recomend.value.lsTrnJobChangeStatus[i].courseName)
                            ? (_openBlock(), _createElementBlock("p", {
                                key: 3,
                                class: "p-recommend-text-1",
                                innerHTML: recomend.value.lsTrnJobChangeStatus[i].courseName
                              }, null, 8, _hoisted_56))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.clientNameRemindOther)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("p", {
                        class: "p-recommend-text-1",
                        innerHTML: recomend.value.clientNameRemindOther
                      }, null, 8, _hoisted_59)
                    ]))
                  : _createCommentVNode("", true),
                (recomend.value.purposeAgentMemo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _hoisted_61,
                      _createElementVNode("p", {
                        class: "p-recommend-text-1",
                        innerHTML: recomend.value.purposeAgentMemo
                      }, null, 8, _hoisted_62)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(RouterLink), {
                class: "p-recommend-button --type-1",
                to: "/recommend/form/"
              }, {
                default: _withCtx(() => [
                  _hoisted_63
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_64, [
        _createElementVNode("a", {
          class: "g-pagetop",
          href: "#",
          "aria-label": "ページトップへ戻る",
          onClick: _withModifiers(scrollToTop, ["prevent"])
        }, _hoisted_67, 8, _hoisted_65)
      ])
    ]),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ], 64))
}
}

})